import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalAttraction } from '../models/local-attraction.model';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
import { AgmMap } from '@agm/core';
import { LatLon } from '../../util/geodesy/latlon';
import { GoogleService } from '../../google/google.service';
import { LocalAttractionService } from '../service/local-attraction.service';
import { CountriesService } from '../../shared/services/countries.service';
var EditLocalAttractionComponent = /** @class */ (function () {
    function EditLocalAttractionComponent(_matDialogRef, _snackBar, data, _google, _cdref, _localAttractionService, countriesService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._google = _google;
        this._cdref = _cdref;
        this._localAttractionService = _localAttractionService;
        this.countriesService = countriesService;
        this.isNew = false;
        this.isLoading = true;
        this.postalCodePlaceHolder = '';
        this.states = new Array();
        this.localAttraction = data.localAttraction || new LocalAttraction();
        this.isNew = data.isNew || false;
        this.airportID = data.airID;
        this.origLocalAttraction = Object.assign(new LocalAttraction(), data.localAttraction);
        this.itemsToChange = new Set();
        this.selectedName = this.localAttraction.name;
        // this.selectedAddress = this.localAttraction.address;
        this.selectedStreet1 = this.localAttraction.street1;
        this.selectedCity = this.localAttraction.city;
        this.selectedState = this.localAttraction.state;
        this.selectedZip = this.localAttraction.zip;
        if (this.localAttraction.country && this.localAttraction.country.length > 0) {
            this.selectedCountry = this.localAttraction.country;
        }
        else {
            this.selectedCountry = 'US';
        }
        if (this.isNew) {
            this.selectedTravelType = '';
            this.latlon = this.localAttraction.location;
        }
        else {
            this.selectedTravelType = this.getTravelType(this.localAttraction);
        }
        if (this.localAttraction.location && this.localAttraction.location.lat && this.localAttraction.location.lon) {
            this.latlon = this.localAttraction.location;
        }
        else {
            this.latlon = data.airportLocation;
        }
        if (this.localAttraction.phone) {
            this.selectedPhone = formatPhoneString(this.localAttraction.phone);
        }
        else {
            this.selectedPhone = '';
        }
        this.selectedWebsite = this.localAttraction.website;
    }
    EditLocalAttractionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl(this.selectedName, [Validators.required, Validators.maxLength(256)]),
            street1: new FormControl(this.selectedStreet1, [Validators.required, Validators.maxLength(100)]),
            city: new FormControl(this.selectedCity, [Validators.required, Validators.maxLength(50)]),
            state: new FormControl(this.selectedState),
            zip: new FormControl(this.selectedZip, [Validators.required, Validators.maxLength(20)]),
            country: new FormControl(this.selectedCountry, [Validators.required, Validators.maxLength(30)]),
            type: new FormControl(this.selectedTravelType, [Validators.required]),
            phone: new FormControl(formatPhoneString(this.selectedPhone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
            website: new FormControl(this.selectedWebsite, [Validators.maxLength(256),
                Validators.pattern('^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$')])
        });
        this.isLoading = false;
        // this.formGroup.patchValue({country: this.selectedCountry || ''});
        // this.formGroup.patchValue({state: this.selectedState || ''});
        this._setPostalCodeValidation(this.selectedCountry);
    };
    EditLocalAttractionComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nativeLocalAttractionMap, _a, e_1, _b, e_2;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this._initMap()];
                    case 1:
                        nativeLocalAttractionMap = _c.sent();
                        nativeLocalAttractionMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getCountries()];
                    case 3:
                        _a.countries = _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 5];
                    case 5:
                        if (!this.selectedCountry) return [3 /*break*/, 9];
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        _b = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.selectedCountry)];
                    case 7:
                        _b.states = _c.sent();
                        this.states.length ? this.formGroup.controls['state'].setValidators([Validators.required, Validators.maxLength(40)]) :
                            this.formGroup.controls['state'].setValidators([Validators.maxLength(30)]);
                        return [3 /*break*/, 9];
                    case 8:
                        e_2 = _c.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    EditLocalAttractionComponent.prototype._initMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.popupMap.mapReady.subscribe(function (map) {
                            _this._nativeLocalAttractionMap = map;
                            resolve(map);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    EditLocalAttractionComponent.prototype.getTravelType = function (attraction) {
        switch (attraction.travelType) {
            case 'Restaurant Nearby':
                return 'Restaurant Nearby';
            case 'Restaurant On Field':
                return 'Restaurant On Field';
            case 'Accommodations':
                return 'Accommodations';
            case 'Transportation':
                return 'Transportation';
            case 'Attractions':
                switch (attraction.travelRef) {
                    case 'Museum':
                        return 'Museum';
                    case 'Golf':
                        return 'Golf';
                    case 'National Park':
                        return 'National Park';
                    case 'State or Local Park':
                        return 'State or Local Park';
                }
        }
        return 'Attractions';
    };
    EditLocalAttractionComponent.prototype.hasAddress = function () {
        if (this.selectedCountry && this.selectedCity && this.selectedStreet1) {
            return (this.selectedCountry.length > 0 && this.selectedCity.length > 0 && this.selectedStreet1.length > 0);
        }
        else {
            return false;
        }
    };
    /**
     * triggered when value inside countries dropdown changes; event.value contains two digit country code.
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    EditLocalAttractionComponent.prototype.countryChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if value property is empty return
                        if (!event.value) {
                            return [2 /*return*/];
                        }
                        if (!(event.source.id.toString() === '1')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._setAddressForm(event.value)];
                    case 1:
                        _a.sent();
                        if (event.value === this.selectedCountry) {
                            this.formGroup.patchValue({ state: this.selectedState || '' });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * changes states dropdown when a different country is chosen.
     * also changes validators depending on whether or states list exists for country
     * @param {string} value
     * @return {Promise<void>}
     * @private
     */
    EditLocalAttractionComponent.prototype._setAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 1:
                        _a.states = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 3];
                    case 3:
                        this.formGroup.patchValue({ state: '' });
                        // this.isLoading = false;
                        if (!this.states.length) {
                            this.formGroup.controls['state'].setValidators([]);
                        }
                        else {
                            this.formGroup.controls['state'].setValidators([Validators.required]);
                        }
                        this._setPostalCodeValidation(value);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If countryCode is 'US', Postal Code field becomes required.
     * @param {string} countryCode
     * @private
     */
    EditLocalAttractionComponent.prototype._setPostalCodeValidation = function (countryCode) {
        if (countryCode === 'US') {
            this.postalCodePlaceHolder = 'Zip Code *';
            this.formGroup.controls['zip'].setValidators([
                Validators.required,
                Validators.pattern('^\\d{5}$')
            ]);
            this.formGroup.controls['zip'].updateValueAndValidity();
        }
        else {
            this.postalCodePlaceHolder = 'Postal Code';
            this.formGroup.controls['zip'].setValidators([Validators.maxLength(9)]);
            this.formGroup.controls['zip'].updateValueAndValidity();
        }
    };
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditLocalAttractionComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    EditLocalAttractionComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    EditLocalAttractionComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    EditLocalAttractionComponent.prototype.setMarkerToAddress = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var address, gc, geom, offset, bounds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        address = this.selectedStreet1 + ', ' + this.selectedCity + ', ' + this.selectedCountry;
                        return [4 /*yield*/, this._google.geocode({ address: address })];
                    case 2:
                        gc = _a.sent();
                        if (gc[0]) {
                            this._cdref.detectChanges();
                            geom = gc[0].geometry;
                            switch (geom.location_type) {
                                case google.maps.GeocoderLocationType.ROOFTOP:
                                case google.maps.GeocoderLocationType.RANGE_INTERPOLATED:
                                    this.latlon = new LatLon(geom.location.lat(), geom.location.lng());
                                    this._nativeLocalAttractionMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                                    break;
                                case google.maps.GeocoderLocationType.GEOMETRIC_CENTER:
                                default:
                                    // When only the geometric center or an approximate location is available, Google returns a location instead
                                    // of bounds. However, since the location is approximate, instead of showing a marker,
                                    // we center the map on the location and zoom out a bit.
                                    this.latlon = new LatLon(geom.location.lat(), geom.location.lng());
                                    this._nativeLocalAttractionMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                                    offset = 0.08;
                                    bounds = new google.maps.LatLngBounds();
                                    bounds.extend(new google.maps.LatLng(this.latlon.lat + offset, this.latlon.lon + offset));
                                    bounds.extend(new google.maps.LatLng(this.latlon.lat - offset, this.latlon.lon - offset));
                                    this._nativeLocalAttractionMap.fitBounds(bounds);
                                    break;
                                /* default:
                                  if (geom.bounds) {
                                    // When only approximate location is available, use bounds instead of lat/lon
                                    this.bounds = geom.bounds.toJSON();
                                    this._nativeMap.fitBounds(this.bounds);
                                  } */
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EditLocalAttractionComponent.prototype.pinDropped = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.latlon && this.latlon.lat && this.latlon.lon) {
                    Object.assign(this.latlon, new LatLon(event.coords.lat, event.coords.lng));
                }
                else {
                    this.latlon = new LatLon(event.coords.lat, event.coords.lng);
                }
                return [2 /*return*/];
            });
        });
    };
    EditLocalAttractionComponent.prototype.setTravelType = function (attractionType) {
        switch (attractionType) {
            case 'Restaurant Nearby':
                return 'Restaurant Nearby';
            case 'Restaurant On Field':
                return 'Restaurant On Field';
            case 'Accommodations':
                return 'Accommodations';
            case 'Transportation':
                return 'Transportation';
            case 'Museum':
            case 'Golf':
            case 'National Park':
            case 'State or Local Park':
                return 'Attractions';
        }
        return 'Attractions';
    };
    EditLocalAttractionComponent.prototype.setTravelRef = function (attractionType) {
        switch (attractionType) {
            case 'Museum':
                return 'Museum';
            case 'Golf':
                return 'Golf';
            case 'National Park':
                return 'National Park';
            case 'State or Local Park':
                return 'State or Local Park';
        }
        return null;
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditLocalAttractionComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.localAttraction.travelType = this.setTravelType(this.formGroup.value.type);
                        this.localAttraction.travelRef = this.setTravelRef(this.formGroup.value.type);
                        this.localAttraction.phone = undoPhoneFormat(this.formGroup.value.phone);
                        this.localAttraction.website = this.formGroup.value.website;
                        this.localAttraction.name = this.formGroup.value.name;
                        this.localAttraction.address = '';
                        this.localAttraction.street1 = this.formGroup.value.street1;
                        this.localAttraction.city = this.formGroup.value.city;
                        this.localAttraction.state = this.formGroup.value.state;
                        this.localAttraction.zip = this.formGroup.value.zip;
                        this.localAttraction.country = this.formGroup.value.country;
                        this.localAttraction.location = this.latlon;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._localAttractionService.postLocalAttraction(this.airportID, this.localAttraction)];
                    case 1:
                        res = _a.sent();
                        this.localAttraction = LocalAttraction.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._localAttractionService.putLocalAttraction(this.airportID, this.localAttraction)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.localAttraction, LocalAttraction.parse(res));
                        this.localAttraction = LocalAttraction.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, localAttraction: this.localAttraction });
                        return [3 /*break*/, 6];
                    case 5:
                        e_4 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditLocalAttractionComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditLocalAttractionComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.localAttraction, this.origLocalAttraction);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditLocalAttractionComponent;
}());
export { EditLocalAttractionComponent };
